import Perfil from './perfil'
import Empresa from './empresa'

export default class Usuario {
  constructor(id, nome, email, login, ativo) {
    this.id = id
    this.nome = nome
    this.email = email
    this.login = login
    this.ativo = ativo
    this.perfil = new Perfil()
    this.empresa = new Empresa()
  }
}
